import {
	CREATE_INTEGRATION_REQUESTED,
	CREATE_INTEGRATION_SUCCEED,
	CREATE_INTEGRATION_FAILED,
	RETRIEVE_INTEGRATIONS_REQUESTED,
	RETRIEVE_INTEGRATIONS_SUCCEED,
	RETRIEVE_INTEGRATIONS_FAILED,
	RESETALL_INTEGRATIONS,
	RETRIEVE_ONE_INTEGRATION_REQUESTED,
	RETRIEVE_ONE_INTEGRATION_SUCCEED,
	RETRIEVE_ONE_INTEGRATION_FAILED,
	RESET_CURRENT_INTEGRATION,
	UPDATE_INTEGRATION_REQUESTED,
	UPDATE_INTEGRATION_SUCCEED,
	UPDATE_INTEGRATION_FAILED
} from "actions/api/integrations/actions";

import Integration from "models/integration";

export const initialState = {
	current: null,
	currentId: null,
	currentLoading: false,
	updating: false,
	values: null,
	loading: false,
	errors: null
};

const integrations = (state = initialState, action) => {
	switch (action.type) {
		case CREATE_INTEGRATION_REQUESTED:
		case UPDATE_INTEGRATION_REQUESTED:
			return { ...state, updating: true };

		case CREATE_INTEGRATION_SUCCEED: {
			const integrationInstance = new Integration(action.data);

			return {
				...state,
				current: integrationInstance,
				currentId: integrationInstance.id,
				updating: false
			};
		}

		case CREATE_INTEGRATION_FAILED:
			return { ...state, updating: false, errors: action.errors };

		case RETRIEVE_INTEGRATIONS_REQUESTED:
			return { ...state, loading: true };

		case RETRIEVE_INTEGRATIONS_SUCCEED: {
			const newValues = state.values ? [...state.values] : [];

			return {
				...state,
				values: [
					...newValues,
					...action.data.map(value => new Integration(value))
				],
				loading: false
			};
		}

		case RETRIEVE_INTEGRATIONS_FAILED:
			return { ...state, loading: false, errors: action.errors };

		case RETRIEVE_ONE_INTEGRATION_REQUESTED:
			return { ...state, currentLoading: true };

		case RETRIEVE_ONE_INTEGRATION_SUCCEED:
		case UPDATE_INTEGRATION_SUCCEED: {
			const newIntegration = new Integration(action.data);

			return {
				...state,
				current: newIntegration,
				currentId: newIntegration.id,
				currentLoading: false,
				updating: false
			};
		}

		case RETRIEVE_ONE_INTEGRATION_FAILED:
			return { ...state, currentLoading: false, errors: action.errors };

		case RESET_CURRENT_INTEGRATION: {
			return {
				...state,
				current: null,
				currentId: null,
				currentLoading: false
			};
		}

		case UPDATE_INTEGRATION_FAILED:
			return { ...state, updating: false, errors: action.errors };

		case RESETALL_INTEGRATIONS:
			return initialState;

		default:
			return state;
	}
};

export default integrations;
